import { useQuery } from 'react-query';
import axios from 'axios';
import { logOutUser, generateToastError } from '../../../utils';
import { queryKeys } from '../queryKeys';

const httpStatuses = { unauthorized: 401, error: 500 };

export const useQueryGetSurveyResults = (userToken, navigate, toast, page = 1, limit = 10, search = '', schoolId = '') => {
  const queryKey = [queryKeys.getSurveyResults, { page, limit, search, schoolId }];

  const queryFn = ({ queryKey }) => {
    const params = {
      page: queryKey[1].page,
      limit: queryKey[1].limit,
      ...(queryKey[1].search && { search: queryKey[1].search }),
      ...(queryKey[1].schoolId && { schoolId: queryKey[1].schoolId })
    };

    return axios.get(`${process.env.REACT_APP_SERVER_URL}/api/admin/survey-results`, {
      headers: { Authorization: `Bearer ${userToken}` },
      params
    });
  };

  return useQuery(queryKey, queryFn, {
    enabled: true,
    retry: 0,
    refetchOnWindowFocus: false,
    cacheTime: 72000,
    staleTime: Infinity,
    select: (data) => {
      const surveys = data?.data?.data?.surveys || [];
      const pagination = data?.data?.data?.pagination || {};

      // Format surveys to match the expected structure
      const formattedSurveys = surveys.map((survey) => {
        const user = survey.user || {};
        const participant = survey.participant || {};
        const displayUser = user._id ? user : participant;
        
        // Get survey title from surveyData
        const title = survey.surveyData?.title || 'Untitled';
        const Name = displayUser ? `${displayUser.fname || ''} ${displayUser.lname || ''}`.trim() : 'Unknown';
        const userImage = displayUser?.image || '';
        const submittedDate = survey.timestamp ? new Date(survey.timestamp) : (survey.createdAt ? new Date(survey.createdAt) : null);

        return {
          _id: survey._id,
          Name,
          title,
          surveyData: survey.surveyData || {}, // Include full surveyData from API
          image: userImage,
          createdAt: submittedDate,
          timestamp: submittedDate,
          user: displayUser,
          participant: participant._id ? participant : null,
          sessionId: survey.sessionId,
          schoolId: survey.schoolId
        };
      });

      return {
        surveys: formattedSurveys,
        pagination: {
          currentPage: pagination.currentPage || page,
          totalPages: pagination.totalPages || 1,
          totalCount: pagination.totalCount || 0,
          limit: pagination.limit || limit,
          hasNextPage: pagination.hasNextPage || false,
          hasPrevPage: pagination.hasPrevPage || false
        }
      };
    },
    onError: (e) => {
      if (e?.response?.status === httpStatuses.unauthorized) {
        logOutUser(navigate);
        return;
      }
      generateToastError(toast, e);
    },
  });
};

